import React, { useState, useEffect, useCallback } from 'react';
import { Table, notification } from 'antd';
import { formatPrice } from '../../../../../utils/format';
import { apiDepositEntriesList } from '../../../../../api/deposits';

const DepositEntriesList = ({ depositId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchEntries = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const filters = {
        page: params.page || 1,
        page_size: params.pageSize || 10,
      };
      const response = await apiDepositEntriesList(depositId, filters);
      setData(response.results || []);
      setPagination(prev => ({
        ...prev,
        total: response.count || 0,
        current: params.page || 1,
      }));
    } catch (error) {
      notification.error({
        message: "Erro",
        description: "Ocorreu um erro ao buscar os lançamentos do depósito.",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  }, [depositId]);

  useEffect(() => {
    if (depositId) {
      fetchEntries();
    }
  }, [depositId, fetchEntries]);

  const handleTableChange = (pag) => {
    fetchEntries({
      page: pag.current,
      pageSize: pag.pageSize,
    });
  };

  const columns = [
    {
      title: 'Lançamento',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Valor',
      dataIndex: 'amount',
      key: 'amount',
      render: (val) => {
        const isDebit = Number(val) < 0;
        return (
          <span style={{ color: isDebit ? '#da0419' : '#21ae41' }}>
            {formatPrice(val)}
          </span>
        );
      },
    },
  ];

  if (!data.length && !loading) {
    return <p>Nenhum lançamento adicional neste depósito.</p>;
  }

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      size="small"
      pagination={{
        current: pagination.current,
        total: pagination.total,
        pageSize: pagination.pageSize,
        showSizeChanger: false,
      }}
      onChange={handleTableChange}
      bordered
      rowKey={(record) => record.id}
      scroll={{ x: 400 }}
    />
  );
};

export default DepositEntriesList;
